"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderByGenerator = exports.toKeyMap = exports.getKeySelectorAndComparer = exports.getIterableGenerator = void 0;
function getIterableGenerator(src) {
    return Array.isArray(src) || typeof src === 'string'
        ? function* () {
            for (let i = 0; i < src.length; i++) {
                yield src[i];
            }
        }
        : function* () {
            for (const item of src) {
                yield item;
            }
        };
}
exports.getIterableGenerator = getIterableGenerator;
function getKeySelectorAndComparer(overrideKeySelector, others) {
    const passedKeySelector = typeof overrideKeySelector === 'function';
    const equalityComparer = typeof others[others.length - (passedKeySelector ? 1 : 2)] === 'function'
        ? others.pop()
        : undefined;
    const keySelector = overrideKeySelector !== null && overrideKeySelector !== void 0 ? overrideKeySelector : others.pop();
    const isIterableArray = (arr) => arr.every(x => Symbol.iterator in Object(x));
    if (typeof keySelector !== 'function' ||
        (equalityComparer !== undefined && typeof equalityComparer !== 'function') ||
        others.length === 0 ||
        !isIterableArray(others)) {
        throw new Error('Invalid use of overloads.');
    }
    return [others, keySelector, equalityComparer];
}
exports.getKeySelectorAndComparer = getKeySelectorAndComparer;
function toKeyMap(src, keySelector) {
    const map = new Map();
    for (const item of src) {
        const key = keySelector(item);
        const curr = map.get(key);
        if (curr !== undefined) {
            curr.push(item);
        }
        else {
            map.set(key, [item]);
        }
    }
    return map;
}
exports.toKeyMap = toKeyMap;
function* orderByGenerator(src, ascending, selector, comparer) {
    const map = toKeyMap(src, selector);
    const sortedKeys = [...map.keys()].sort((a, b) => {
        if (comparer) {
            return comparer(a, b);
        }
        if (a > b) {
            return 1;
        }
        else if (a < b) {
            return -1;
        }
        else {
            return 0;
        }
    });
    if (ascending) {
        for (let i = 0; i < sortedKeys.length; i++) {
            const items = map.get(sortedKeys[i]);
            yield items !== null && items !== void 0 ? items : [];
        }
    }
    else {
        for (let i = sortedKeys.length - 1; i >= 0; i--) {
            const items = map.get(sortedKeys[i]);
            yield items !== null && items !== void 0 ? items : [];
        }
    }
}
exports.orderByGenerator = orderByGenerator;
//# sourceMappingURL=utilityFunctions.js.map